<template>      
  <v-content>                              
    <!--<app-left-drawer class="app-left-drawer"></app-left-drawer>-->                          
    <router-view style="padding-bottom: 105px;" />                                            
    <v-footer class="pa-2 green darken-4 white--text">
      <span class="caption">
          {{footerCopyright}}
      </span> 
      <div class="spacer"></div> 
      <span class="caption mr-1"> {{footerTagline}} </span> 
      <i aria-hidden="true" class="v-icon orange--text material-icons" style="font-size: 20px;">{{footerIcon}}</i>
    </v-footer>
  </v-content>      
</template>

<script>
import PageHeader from './PageHeader';
import AppLeftDrawer from './LeftDrawer';

export default {
  name: 'app-content',
  components: { 
    PageHeader,  
    AppLeftDrawer
  },
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 60
    },
    footerCopyright: 'RNF v.1.1 © 2020',
    footerTagline  : '',
    footerIcon     : '',    
  }),

  methods: {
   
  }
};
</script>
